import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import type {
  QueryParamsDto,
  ResponseDto,
  MembershipTierDto,
} from "@mimber/schema"
import { membershipTiersKeys } from "../membership-tiers.utils"

/**
 * Organization-specific hook for fetching organization membership tiers
 * Can only be used in mimber-organization app
 * The organization context is automatically handled by ServerContext
 */
export const useMembershipTiers = (
  params?: QueryParamsDto,
  options?: UseQueryOptions<ResponseDto<MembershipTierDto[]>, Error>
): UseQueryResult<ResponseDto<MembershipTierDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useMembershipTiers")

  const { server } = useServerContext()

  return useQuery({
    queryKey: membershipTiersKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<ResponseDto<MembershipTierDto[]>>(
        buildQueryString("membership-tiers", params)
      )
      return response.data
    },
    ...options,
  })
}
